module.exports = __webpack_public_path__ + "img/lianrun02.48d69332.png";